module.exports = __webpack_public_path__ + "static/img/wentibaoxiu.36f1d001.png";